import React from "react";

/**
 * MTS brand mark — minimalist monogram.
 * A compact rounded square containing the "MTS" wordmark in white.
 * Echoes the site's central hub node styling (AsiaNetwork, AboutCycle).
 * Sizes: `size` prop controls pixel dimensions (default 28).
 */
export default function Logo({ size = 28, className = "" }) {
  return (
    <span
      aria-label="MTS"
      className={`inline-flex items-center justify-center rounded-[7px] bg-[#0a0a0a] text-white select-none ${className}`}
      style={{
        width: size,
        height: size,
        fontFamily: "'Inter', sans-serif",
        fontWeight: 600,
        fontSize: Math.round(size * 0.36),
        letterSpacing: "0.06em",
        lineHeight: 1,
      }}
    >
      MTS
    </span>
  );
}
